@if (isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in"
    (click)="close()"
  >
    <div
      class="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
        <div class="flex items-center gap-3">
          <h3 class="text-xl font-bold text-gray-800 flex items-center gap-2">
            <lucide-icon [img]="modalConfig().icon" class="w-5 h-5 text-brand"></lucide-icon>
            {{ modalConfig().title }}
          </h3>
          @if (modalConfig().showInProgressBadge) {
            <span class="px-2 py-0.5 bg-amber-100 text-amber-700 text-xs font-semibold rounded-full">
              In Development
            </span>
          }
        </div>
        <button (click)="close()" class="text-gray-400 hover:text-gray-600 cursor-pointer">
          <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6">
        @if (isSubmitted()) {
          <!-- Success State -->
          <div class="text-center py-8">
            <div class="w-16 h-16 rounded-full bg-green-100 text-green-600 flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h4 class="text-lg font-bold text-gray-800 mb-2">Thank You! 💜</h4>
            <p class="text-gray-500">Your feedback helps us build a better platform for educators.</p>
          </div>
        } @else {
          <!-- Feedback Form -->
          <p class="text-sm text-gray-500 mb-4">
            {{ modalConfig().description }}
          </p>

          <textarea
            [value]="feedbackText()"
            (input)="onFeedbackInput($event)"
            [disabled]="isSubmitting()"
            [placeholder]="modalConfig().placeholder"
            class="w-full h-32 p-4 border border-gray-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-brand/50 focus:border-brand transition-all text-gray-700 placeholder-gray-400 disabled:bg-gray-50 disabled:cursor-not-allowed"
          ></textarea>

          @if (error()) {
            <p class="text-sm text-red-500 mt-2">{{ error() }}</p>
          }

          <div class="flex justify-end mt-4">
            <button
              (click)="submitFeedback()"
              [disabled]="!feedbackText().trim() || isSubmitting()"
              class="flex items-center gap-2 px-5 py-2.5 bg-brand hover:bg-brand-dark text-white rounded-xl font-bold text-sm transition-all shadow-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              @if (isSubmitting()) {
                <div class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                Sending...
              } @else {
                <lucide-icon [img]="icons.Send" class="w-4 h-4"></lucide-icon>
                Send Feedback
              }
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
